import React from 'react';
import { Link } from 'react-router-dom';
import blogPosts from './BlogData';
import './Blog.css';
import { useTranslation } from 'react-i18next';
const Blog = () => {
  const { t } = useTranslation();  // Çeviri fonksiyonunu alıyoruz

  // Blog verilerini dönerken her post için dil çevirisini ekliyoruz
  const translatedBlogPosts = blogPosts.map(post => ({
    ...post,
    title: t(post.title),  // Çevirisini yapıyoruz
    short: t(post.short),   // Çevirisini yapıyoruz
    content: t(post.content) // Çevirisini yapıyoruz
  }));

  return (
    <div className="blog-container">
      <h1 className="blog-header">{t("blog.title")}</h1>
      <div className="blog-grid">
        {translatedBlogPosts.map((post) => (
          <div className="blog-card" key={post.id}>
            <img src={post.image} alt={post.title} className="blog-image" />
            <h2 className="blog-title">{post.title}</h2>
            <p className="blog-content">{post.short}</p>
            <Link to={`/blog/${post.id}`} className="read-more">{t("blog.button")} →</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
